import React, { useEffect, useState } from 'react';
import Joi from "joi";
import './_CouponForm.scss'
import { Form, Input } from "semantic-ui-react";
import { Button } from "components/atoms/Button/Button";
import { Popup } from "controls";
import { useDispatch } from 'react-redux';
import { getDiscount } from 'actions/payment';
import { useFieldset } from 'controls/hooks';
import { COUPON_TYPES, SUBSCRIPTION_OPTIONS } from 'components/Authentication/SignUpForm/types';
import CouponModal from './CouponModal';

const couponTemplate = {
    coupon: "",
  };

const couponSchema = {
    coupon: Joi.string(),
  };

const CouponForm = ({ setDiscount, discount, onChange, subscriptionPlan }) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [haveCoupon, setHaveCoupon] = useState(false);

    const isSubscriptionMonthly = () => subscriptionPlan === SUBSCRIPTION_OPTIONS.monthly

    const validateCoupon = async({ coupon }) => {
        setIsLoading(true);
        const couponData = { couponCode: coupon} ;
        const newDiscount = await dispatch(getDiscount(couponData));

        if (newDiscount) {
            setDiscount(newDiscount)
        }
        onChange(coupon) 
        setIsLoading(false)
    }

    const onSubmit = (data) => {
        validateCoupon(data)
    }

    const {
        fields: { coupon },
        submit,
      } = useFieldset({
        schema: couponSchema,
        source: couponTemplate ,
        onSubmit: onSubmit,
      });

      useEffect(()=> {
        if(isSubscriptionMonthly()){
            setHaveCoupon(false)
            setDiscount({
                type: COUPON_TYPES.percent,
                value: 0
            })
        }
      },[subscriptionPlan])

    return (
        <>
        <label 
            className="coupon-form__text coupon-form__label"
            onClick={() => isSubscriptionMonthly() ? setShowModal(true) : setHaveCoupon(!haveCoupon)}
        >
            Do you have a coupon?
        </label>
        {haveCoupon &&
            <>
                <div className="coupon-form">
                    <Form.Field className="coupon-form__input" error={coupon.errored}>
                        <Popup
                            message="Enter your coupon"
                            enabled={coupon.errored}
                        >
                        <Input
                            fluid
                            placeholder="Coupon"
                            value={coupon.value}
                            onChange={coupon.onChange}
                        />
                        </Popup>
                    </Form.Field>
                    <Button
                        extraStyle="coupon-form__button"
                        text={isLoading ? 'loading . . .' : 'Apply Code' }
                        onClick={submit}
                        type="button"
                    />
                </div>
                {discount.value !== 0 &&
                    <p className="coupon-form__text">
                        {
                            `Coupon activated: saved ${discount.type === COUPON_TYPES.price ? `$${discount.value}` : `${discount.value * 100}%`} via "${discount.couponCode}"`
                        }
                    </p> 
                }
            </>
        }
        {showModal &&
            <CouponModal onCancel= {() => setShowModal(false)} />
        }
        </>
    )
}

export default CouponForm
